import localStorage from 'local-storage';
import { isMobile } from 'helpers/isMobile';
const STORAGE_KEY = 'abandonedCartMenuItems';

function getMenuItemIds(menuItems) {
  if (!menuItems?.length) return '';
  return menuItems
    .map((item) => `${item._id}:${item.quantity}`)
    .sort()
    .join(',');
}

function hasCartChanged(menuItems) {
  const current = getMenuItemIds(menuItems);
  const previous = localStorage.get(STORAGE_KEY) || '';
  if (current === previous) return false;
  localStorage.set(STORAGE_KEY, current);
  return true;
}

function getFlattenedSubModifiers(menuItem) {
  if (!Array.isArray(menuItem?.selectedModifiers)) return [];

  const subModifierNames = menuItem.selectedModifiers
    .flatMap((modifier) => modifier?.subModifiers || [])
    .filter((subModifier) => Boolean(subModifier))
    .filter((subModifier) =>
      typeof subModifier.quantity === 'number' ? subModifier.quantity > 0 : true
    )
    .map((subModifier) => subModifier?.name)
    .filter((name) => typeof name === 'string' && name.trim().length > 0);

  return [...new Set(subModifierNames)];
}

function buildPayload(currentOrder, storeConfig, userDetails) {
  const menuItems = (currentOrder?.menuItems || []).map((item) => ({
    _id: item._id,
    name: item.name,
    quantity: item.quantity,
    itemPrice: item.itemPrice,
    payablePrice: item.payablePrice,
    categoryId: item.categoryId,
    subModifiers: getFlattenedSubModifiers(item),
  }));

  return {
    storeId: storeConfig?.storeId,
    restaurantId: storeConfig?.restaurantId,
    userId: userDetails?._id,
    menuItems,
    cartTotal: currentOrder?.payableAmount || 0,
    itemCount: menuItems.reduce((sum, item) => sum + (item.quantity || 0), 0),
    orderType: String(currentOrder?.orderType || ''),
    deviceType: isMobile() ? 'mobile' : 'desktop',
  };
}

export default function saveAbandonedCart(
  currentOrder,
  storeConfig,
  userDetails
) {
  if (!userDetails?._id) return;
  if (!currentOrder?.menuItems?.length) return;
  if (!hasCartChanged(currentOrder.menuItems)) return;

  const payload = buildPayload(currentOrder, storeConfig, userDetails);

  fetch(`${storeConfig.cloudFunctionsUrl}/saveAbandonedCart`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).catch(() => {});
}

export function clearAbandonedCartStorage() {
  localStorage.remove(STORAGE_KEY);
}
